import { DomainEntity } from "../DomainEntity";

export class ResourceElement extends DomainEntity {

    HolderId?: string;

}